var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", null)), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 6,
    r: 0.5,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 10,
    r: 0.5,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 14,
    r: 0.5,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 18,
    r: 0.5,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 6,
    r: 0.5,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 10,
    r: 0.5,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14,
    r: 0.5,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 18,
    r: 0.5,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.da03ca64ca7f725a08fdb57fdb2c3d3a.svg";
export { ForwardRef as ReactComponent };